
import Footer from "../footer/footer.component";
import NavigationComponent from "../navigation/NavigationComponent";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import Avatar from "../../assets/images/avatar.jpg";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const ClientLayout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
    <div className="w-full bg-color-white">
      <div>
        <NavigationComponent />
      </div>

      <div className=" mt-3 lg:mt-12 ">{children}</div>
      <FloatingWhatsApp
        phoneNumber="254714818723"
        accountName="Admin Mambahikers"
        avatar={Avatar}
      />
      <section className="">
        <Footer />
      </section>
    </div>
  );
};

export default ClientLayout;
